// src/stockx/base/AuthenticationIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var AuthenticationIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  colorized && /* @__PURE__ */ jsx(
    "path",
    {
      d: "M42.7999 19.2L37.0999 16.2L36 9.79999L29.6 10.7L25 6.29999L20.4 10.8L14 9.79999L12.9 16.2L7.19995 19.2L9.99995 25L7.19995 30.8L12.9 33.8L14 40.2L20.4 39.3L25 43.8L29.6 39.3L36 40.2L37.0999 33.8L42.7999 30.8L40 25L42.7999 19.2ZM25 36.3C18.8 36.3 13.7 31.2 13.7 25C13.7 18.8 18.8 13.7 25 13.7C31.2 13.7 36.2999 18.8 36.2999 25C36.2999 31.2 31.2 36.3 25 36.3Z",
      fill: "#006340"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M22.9 31.1L17.2 25.4L18.7999 23.8L22.7999 27.9L31.1 18.8L32.7999 20.4L22.9 31.1Z",
      fill: colorized ? "#006340" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25 45.3L20 40.4L13.1 41.4L11.9 34.5L5.69998 31.2L8.69998 25L5.59998 18.7L11.8 15.4L13 8.49998L19.9 9.49998L24.9 4.59998L29.9 9.49998L36.8 8.49998L38 15.4L44.2 18.7L41.3 25L44.4 31.3L38.2 34.6L37 41.5L30.1 40.5L25 45.3ZM20.8 38.1L25 42.2L29.2 38.1L35.1 38.9L36.1 33.1L41.3 30.3L38.7 25L41.3 19.7L36.1 16.9L35.1 11.1L29.2 11.9L25 7.79998L20.8 11.9L14.9 11.1L13.9 16.9L8.69998 19.7L11.3 25L8.69998 30.3L13.9 33.1L14.9 38.9L20.8 38.1Z",
      fill: colorized ? "black" : "currentColor"
    }
  )
] });
var AuthenticationIcon_default = AuthenticationIcon;

export {
  AuthenticationIcon_default
};
